import { render, staticRenderFns } from "./EventTicketPurchaseModal.vue?vue&type=template&id=663977ea&scoped=true&"
import script from "./EventTicketPurchaseModal.vue?vue&type=script&lang=ts&"
export * from "./EventTicketPurchaseModal.vue?vue&type=script&lang=ts&"
import style0 from "./EventTicketPurchaseModal.vue?vue&type=style&index=0&id=663977ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663977ea",
  null
  
)

export default component.exports